import styled from "styled-components";

export const IdDiv = styled.div`
  color: ${({ theme }) => theme.colors.primaryBlue};
`;

export const Title = styled.h1`
  margin-top: 0;
`;
